﻿import React, { useState, useEffect } from 'react';
import { pushToDataLayer } from '../dataLayer'

import { HtmlOutput } from './HtmlOutput'

export const CheckboxWithLabel = (props) => {
  const wrappingClass = `single-step__section single-step__section--checkbox`;
  const isValueObject = typeof props.value === 'object' && props.value !== null;
  const error = isValueObject && props.value && props.value.error;
  const [isChecked, setIsChecked] = useState(isValueObject ? props.value.selected : props.value);

  const onChangeHandler = (e) => {
    setIsChecked(!isChecked);

    if (props.isAccessDevice) {
      props.handleClick(e)
    }

		if (isValueObject) {
      pushToDataLayer({ event: 'checkbox_change', label: props.text, value: !props.value.selected });
      props.setValue({ ...props.value, selected: !props.value.selected });
		}
    else if (!props.isAccessDevice) {
      pushToDataLayer({ event: 'checkbox_change', label: props.text, value: !props.value });
      props.setValue(!props.value);
    }
  };

  useEffect(() => setIsChecked(isValueObject ? props.value.selected : props.value), [props.value])

  return (
    <div className={wrappingClass}>
      <label className="single-step__section__checkbox-wrapper" aria-disabled={props.disabled}>
        <input className="single-step__section__checkbox-original" type="checkbox" aria-invalid={error ? true : null} checked={isChecked} onChange={onChangeHandler} disabled={props.disabled}/>
        <span className="single-step__section__checkbox-check" />
        {props.isAccessDevice && props.children}
        {!props.isAccessDevice && <span className="single-step__section__checkbox-label">{<HtmlOutput html={props.text} />}{error && <span className="validation-error">{error}</span>}</span>}
      </label>
    </div>
  );
}